import { makeStyles } from '@fluentui/react-components';

export const usePolicyPageStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: '100%',
        minWidth: 0,
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
    },
});
